import React from 'react';
import styles from './index.module.less';

export function Bank(props) {
    return <>bank</>
}